var _defs, _g, _polygon, _path, _g2, _path2, _path3, _path4, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 672.69 357.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #809eb5;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        opacity: .3;\n      }\n\n      .cls-2, .cls-5, .cls-6 {\n        fill: #c6c6c6;\n      }\n\n      .cls-7 {\n        fill: #9ed8f0;\n      }\n\n      .cls-8, .cls-3, .cls-9, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        fill: #82a2bb;\n      }\n\n      .cls-12, .cls-13 {\n        opacity: .2;\n      }\n\n      .cls-12, .cls-14 {\n        fill: #9ab7cb;\n      }\n\n      .cls-15 {\n        fill: #00466e;\n      }\n\n      .cls-16 {\n        fill: #2f6e76;\n      }\n\n      .cls-17 {\n        fill: #7692a7;\n      }\n\n      .cls-18 {\n        fill: #7b98ae;\n      }\n\n      .cls-19 {\n        fill: #738ea2;\n      }\n\n      .cls-20 {\n        fill: #556670;\n      }\n\n      .cls-21 {\n        fill: #718c9f;\n      }\n\n      .cls-22 {\n        fill: #3c8b94;\n      }\n\n      .cls-23 {\n        fill: #4a4a4a;\n      }\n\n      .cls-24 {\n        fill: #6f8a9d;\n      }\n\n      .cls-25 {\n        fill: #7b99af;\n      }\n\n      .cls-26 {\n        fill: #323232;\n      }\n\n      .cls-27 {\n        fill: #7a7b7b;\n      }\n\n      .cls-28 {\n        fill: #2a2a3b;\n      }\n\n      .cls-29 {\n        fill: #09414d;\n      }\n\n      .cls-30 {\n        fill: #7591a6;\n      }\n\n      .cls-31, .cls-9, .cls-32, .cls-14 {\n        opacity: .7;\n      }\n\n      .cls-31, .cls-33 {\n        fill: #e4f3fb;\n      }\n\n      .cls-34 {\n        fill: #81a0b7;\n      }\n\n      .cls-35 {\n        fill: #7894ab;\n      }\n\n      .cls-36 {\n        fill: #708b9d;\n      }\n\n      .cls-37 {\n        fill: #6b8798;\n      }\n\n      .cls-38 {\n        fill: #83a2b9;\n      }\n\n      .cls-39, .cls-40, .cls-41, .cls-42 {\n        opacity: .1;\n      }\n\n      .cls-39, .cls-43 {\n        fill: #0e9dd9;\n      }\n\n      .cls-44 {\n        fill: #f4f8fd;\n      }\n\n      .cls-40 {\n        fill: #025788;\n      }\n\n      .cls-45 {\n        fill: #7f9db4;\n      }\n\n      .cls-46 {\n        fill: #6c8698;\n      }\n\n      .cls-47 {\n        fill: #08505e;\n      }\n\n      .cls-48 {\n        fill: #7490a4;\n      }\n\n      .cls-49 {\n        fill: #f8c0ae;\n      }\n\n      .cls-50 {\n        fill: #718da1;\n      }\n\n      .cls-51 {\n        opacity: .8;\n      }\n\n      .cls-51, .cls-52 {\n        fill: #63abba;\n      }\n\n      .cls-53 {\n        fill: #81a0b9;\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-55 {\n        opacity: .49;\n      }\n\n      .cls-56 {\n        fill: none;\n      }\n\n      .cls-57 {\n        fill: #7d9bb1;\n      }\n\n      .cls-58 {\n        fill: #7693a8;\n      }\n\n      .cls-4 {\n        fill: #5aa3af;\n      }\n\n      .cls-13 {\n        fill: #083f64;\n      }\n\n      .cls-59 {\n        fill: #6d8798;\n      }\n\n      .cls-60 {\n        fill: #7d9cb2;\n      }\n\n      .cls-61 {\n        fill: #e8bfab;\n      }\n\n      .cls-10 {\n        opacity: .6;\n      }\n\n      .cls-62 {\n        fill: #6e889b;\n      }\n\n      .cls-63 {\n        fill: #748ea3;\n      }\n\n      .cls-5 {\n        opacity: .4;\n      }\n\n      .cls-64 {\n        fill: #7694a9;\n      }\n\n      .cls-65 {\n        fill: #7490a5;\n      }\n\n      .cls-66 {\n        fill: #7794a9;\n      }\n\n      .cls-67 {\n        fill: #809eb6;\n      }\n\n      .cls-68 {\n        fill: #5099a6;\n      }\n\n      .cls-42 {\n        fill: #1a2c3d;\n      }\n\n      .cls-69 {\n        fill: #d2d2d2;\n      }\n\n      .cls-70 {\n        fill: #045e93;\n      }\n\n      .cls-71 {\n        fill: #81a1bb;\n      }\n\n      .cls-32 {\n        fill: #addcea;\n      }\n\n      .cls-72 {\n        fill: #6f889c;\n      }\n\n      .cls-73 {\n        fill: #02272f;\n      }\n\n      .cls-74 {\n        fill: #010101;\n      }\n\n      .cls-75 {\n        fill: #7e9bb2;\n      }\n\n      .cls-76 {\n        fill: #0b3653;\n      }\n\n      .cls-77 {\n        fill: #387f8b;\n      }\n\n      .cls-78 {\n        fill: #7a97ac;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "339 311.99 294.01 311.99 305.91 223.42 327.11 223.42 339 311.99"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m309.27,332.91c-57.65,22.23-208.37,47.76-256.61-39.48C-22.3,157.89,89.36,23.09,169.64,42.74c57.64,14.11,92.6,32.39,144.8-3.37,59.06-40.47,236.87-57.01,305.86,16.74,60.78,64.97-4.27,118.39,21.88,169,96.03,185.87-171.64,111.37-223.78,92.59-52.14-18.78-81.12,4.41-109.13,15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m335.66,337.55c-92.6-1.95-355.53,53.73-334.46-141.8C22.27.23,223.32,137.56,314.44,72.14c91.12-65.42,185.12-114.43,278.31-17.85,93.19,96.58,95.33,108.86,55.1,177.32-40.22,68.46-41.33,138.62-169.36,123.72-128.03-14.9-106.78-17.02-142.83-17.78Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "388.07 169.3 387.77 169.31 387.77 169.3 388.07 169.3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m621.39,163.12c.95-2.92,2.05-6.12,3.23-9.46-.5-.45-.82-.73-.82-.73l.42-.7-5.37-4.67-3.8-.31-1.73-1.35-1.17-3.18-1.82-.36v20.46c3.07.08,7.03.19,11.05.29Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "339 311.99 294.01 311.99 305.91 223.42 327.11 223.42 339 311.99"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 310.49,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 308.99,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 307.49,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 305.98,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 304.48,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 302.98,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 301.48,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 299.98,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 298.48,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 296.98,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 295.48,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 293.97,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 292.47,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 290.97,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 289.47,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 287.97,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 286.47,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 284.97,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 283.47,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 281.96,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 280.46,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 278.96,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 277.46,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 294.01,
    y: 275.96,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 294.01,
    y: 274.46,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 294.01,
    y: 272.96,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 294.01,
    y: 271.46,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 294.01,
    y: 269.95,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 294.01,
    y: 268.45,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 294.01,
    y: 266.95,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.01,
    y: 265.45,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 294.01,
    y: 263.95,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 294.01,
    y: 262.45,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 294.01,
    y: 260.95,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 294.01,
    y: 259.45,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 294.01,
    y: 257.94,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 294.01,
    y: 256.44,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 294.01,
    y: 254.94,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 294.01,
    y: 253.44,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 294.01,
    y: 251.94,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 294.01,
    y: 250.44,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 294.01,
    y: 248.94,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 294.01,
    y: 247.44,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 294.01,
    y: 245.93,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 294.01,
    y: 244.43,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 294.01,
    y: 242.93,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 294.01,
    y: 241.43,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 294.01,
    y: 239.93,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 294.01,
    y: 238.43,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 294.01,
    y: 236.93,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 294.01,
    y: 235.43,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 294.01,
    y: 233.92,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 294.01,
    y: 232.42,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 294.01,
    y: 230.92,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 294.01,
    y: 229.42,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 294.01,
    y: 227.92,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 294.01,
    y: 226.42,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 294.01,
    y: 224.92,
    width: 44.99,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 294.01,
    y: 223.42,
    width: 44.99,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 176.97,
    y: 100.12,
    width: 279.07,
    height: 177.3,
    rx: 9.58,
    ry: 9.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 182.52,
    y: 105.61,
    width: 267.74,
    height: 165.97,
    rx: 3.92,
    ry: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 249.98,
    y: 308.85,
    width: 133.06,
    height: 6.28
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m305.3,321.97c-45.8-.08-130.2,1.44-119.78-6.25,10.42-7.69,65.4-.16,110.46-2.73,45.06-2.57,85.86-5.53,131.95-1.73,46.09,3.8,33.56,8.17,13.33,9.41-37.18,2.27-43.77,3.25-65.32,2-63.08-3.65-52.81-.67-70.64-.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m231.19,344.58c-13.14-.04-37.35.7-34.36-3.04,2.99-3.75,18.76-.08,31.69-1.33,12.93-1.25,24.63-2.69,37.85-.84,13.22,1.85,9.63,3.98,3.82,4.58-10.67,1.11-12.56,1.58-18.74.98-18.1-1.78-15.15-.33-20.27-.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m486.95,337.24c-20.19-.05-57.41.97-52.81-4.2,4.59-5.17,28.83-.11,48.7-1.84,19.87-1.73,37.86-3.72,58.18-1.17,20.32,2.56,14.8,5.5,5.88,6.33-16.39,1.53-19.3,2.19-28.8,1.35-27.81-2.45-23.29-.45-31.15-.47Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 187,
    y: 15.58,
    width: 259.75,
    height: 202.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 187,
    y: 15.58,
    width: 259.75,
    height: 17.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 196.53,
    y: 20.85,
    width: 35.99,
    height: 6.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 411.65,
    y: 20.85,
    width: 6.54,
    height: 6.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 420.71,
    y: 20.85,
    width: 6.54,
    height: 6.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 429.77,
    y: 20.85,
    width: 6.54,
    height: 6.54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 194.84,
    y: 49.03,
    width: 80.42,
    height: 3.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 194.84,
    y: 56.59,
    width: 108.34,
    height: 3.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 194.84,
    y: 75.79,
    width: 46.84,
    height: 34.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m209.18,95.58v-9.6c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6,9.6-4.3,9.6-9.6c0-.06,0-.13,0-.19l-9.59.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m220.12,94.19c-.1-5.21-4.35-9.41-9.59-9.41v9.6l9.59-.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 225.86,
    y: 85.99,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.68,
    y: 85.99,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.68,
    y: 87.27,
    width: 4.52,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 225.86,
    y: 92.25,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.68,
    y: 92.25,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 230.68,
    y: 93.54,
    width: 4.52,
    height: 0.76
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 246.62,
    y: 75.97,
    width: 46.84,
    height: 34.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 276.91,
    y: 83.94,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 83.94,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 85.23,
    width: 4.52,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 276.91,
    y: 89.23,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 89.23,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 90.51,
    width: 4.52,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 276.91,
    y: 94.51,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 94.51,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 95.8,
    width: 4.52,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 276.91,
    y: 99.8,
    width: 3.33,
    height: 3.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 99.8,
    width: 7.64,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 281.73,
    y: 101.09,
    width: 4.52,
    height: 0.76
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m261.32,84.23v9.1l3.03-8.57c-.99-.33-2.01-.51-3.03-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m264.69,84.88l-3.25,9.2,9.12-3.47c-1.06-2.66-3.19-4.73-5.87-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m262.23,94.16l9.04-.34c-.05-.99-.25-1.96-.58-2.88l-8.46,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m260.88,84.23c-5.49.14-9.91,4.62-9.91,10.15s4.55,10.17,10.17,10.17,10.17-4.55,10.17-10.17c0-.03,0-.06,0-.1l-10.42.32v-10.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m267.46,94.37c0,3.5-2.84,6.34-6.34,6.34s-6.34-2.84-6.34-6.34,2.84-6.34,6.34-6.34,6.34,2.84,6.34,6.34Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 298.12,
    y: 75.79,
    width: 46.84,
    height: 34.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 329.27,
    y: 83.94,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 83.94,
    width: 5.73,
    height: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 84.91,
    width: 3.39,
    height: 0.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 329.27,
    y: 88.1,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 88.1,
    width: 5.73,
    height: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 89.07,
    width: 3.39,
    height: 0.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 329.27,
    y: 92.27,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 92.27,
    width: 5.73,
    height: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 93.23,
    width: 3.39,
    height: 0.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 329.27,
    y: 96.43,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 96.43,
    width: 5.73,
    height: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 97.4,
    width: 3.39,
    height: 0.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 329.27,
    y: 100.59,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 100.59,
    width: 5.73,
    height: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 332.88,
    y: 101.56,
    width: 3.39,
    height: 0.57
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m322.95,98.49c.63-1.34.99-2.83.99-4.41,0-.99-.15-1.94-.4-2.84l-9.95,2.84,9.36,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m303.34,95.41c.65,5.09,4.99,9.03,10.26,9.03,4.14,0,7.7-2.44,9.36-5.95l-9.36-4.41-10.26,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m312.17,83.84c-5.04.7-8.92,5.01-8.92,10.24,0,.45.04.89.09,1.32l10.26-1.32-1.43-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m319.44,85.54c-1.66-1.14-3.68-1.81-5.85-1.81-.49,0-.96.05-1.43.11l1.43,10.24,5.85-8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m319.44,85.54l-5.85,8.54,9.95-2.84c-.67-2.35-2.14-4.35-4.1-5.7Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 353.48,
    y: 49.03,
    width: 82.84,
    height: 61.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 357.96,
    y: 96.71,
    width: 72.23,
    height: 6.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 357.96,
    y: 83.94,
    width: 72.23,
    height: 6.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 357.96,
    y: 70.19,
    width: 72.23,
    height: 6.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 357.96,
    y: 56.72,
    width: 72.23,
    height: 6.77
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "361.71 103.31 364.75 96 369.64 91.75 374.83 80.43 379.42 75.44 384.31 79.74 389.2 90.84 394.17 85.32 398.98 70.75 404.16 65.63 408.53 71.17 413.65 79.74 418.54 89.14 423.43 87.04 426.68 103.48 361.71 103.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "361.71 103.37 364.75 98.8 369.64 96.13 374.83 89.05 379.42 85.93 384.31 88.62 389.2 95.57 394.17 92.11 398.98 82.99 404.16 79.78 408.53 83.25 413.65 88.62 418.54 94.5 423.43 93.19 426.68 103.48 361.71 103.37"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 194.84,
    y: 116.82,
    width: 150.12,
    height: 94.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 206.1,
    y: 193.13,
    width: 128.42,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 206.1,
    y: 176.26,
    width: 128.42,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 206.1,
    y: 159.38,
    width: 128.42,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 206.1,
    y: 142.5,
    width: 128.42,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 206.1,
    y: 125.62,
    width: 128.42,
    height: 8.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 208.56,
    y: 182.98,
    width: 6.77,
    height: 12.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 267.05,
    y: 167.83,
    width: 6.77,
    height: 28.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 286.54,
    y: 127.68,
    width: 6.77,
    height: 68.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 306.04,
    y: 157.35,
    width: 6.77,
    height: 38.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 325.53,
    y: 171.06,
    width: 6.77,
    height: 24.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 228.06,
    y: 158.65,
    width: 6.77,
    height: 37.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 247.55,
    y: 157.35,
    width: 6.77,
    height: 38.49
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 208.56,
    y: 188.73,
    width: 6.77,
    height: 12.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 267.05,
    y: 173.61,
    width: 6.77,
    height: 27.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 286.54,
    y: 136.73,
    width: 6.77,
    height: 64.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 306.04,
    y: 163.15,
    width: 6.77,
    height: 38.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 325.53,
    y: 176.83,
    width: 6.77,
    height: 24.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 228.06,
    y: 164.45,
    width: 6.77,
    height: 37.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 247.55,
    y: 163.15,
    width: 6.77,
    height: 38.42
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "289.93 122.77 284.23 128.47 295.62 128.47 289.93 122.77"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 353.48,
    y: 116.82,
    width: 82.84,
    height: 44.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 134.16,
    width: 65.96,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 125.41,
    width: 65.96,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 142.91,
    width: 65.96,
    height: 6.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 363.57,
    y: 134.16,
    width: 45.34,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 363.57,
    y: 125.41,
    width: 23.23,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 363.57,
    y: 142.91,
    width: 36.04,
    height: 6.51
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "429.52 153.54 359.55 153.54 359.55 125.77 360.29 125.77 360.29 152.8 429.52 152.8 429.52 153.54"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 353.48,
    y: 167.68,
    width: 82.84,
    height: 43.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 184.37,
    width: 65.96,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 175.63,
    width: 65.96,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 363.57,
    y: 193.12,
    width: 65.96,
    height: 6.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 363.57,
    y: 184.37,
    width: 54.35,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 363.57,
    y: 175.63,
    width: 23.23,
    height: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 363.57,
    y: 193.12,
    width: 46.88,
    height: 6.51
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "429.52 203.76 359.55 203.76 359.55 175.99 360.29 175.99 360.29 203.01 429.52 203.01 429.52 203.76"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m229.96,164.19l10.14-1.23,1.42-1.1.58-3.69.05-1.93-.99-3.45-.29-2.8c-.19-1.89-1.45-3.5-3.23-4.16l-3.1-1.14-4.66,1.45-3.29,2.19.22,7.45,2.49,4.72.69,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m232.44,169.77l3.67-.27c1.04-.08,1.82-.98,1.74-2.02l-.89-7.47-7.44.55.89,7.47c.08,1.04.98,1.82,2.02,1.74Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "239.45 146.91 237.06 147.97 238.01 149.46 237.92 152.63 238.09 155.18 237.52 155.36 236.72 154.07 235.95 154.49 235.93 156.3 236.74 158.24 234.82 160.58 229.27 161.38 226.34 155.19 225.58 149.56 228.36 145.88 234.35 143.52 237.76 143.85 240.81 145.38 239.45 146.91"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m223.17,235.22h29.24v-1.4s1.26-2.13,1.26-2.13l-1.18-3.09s-1.19-11.38-1.31-18.4c-.08-4.95.66-13.81.68-20.3.03-10.07-1.8-14.69-3.23-20.17-.99-3.79-5.98-2.83-5.98-2.83l-15.9.85c-9.27,1.5-11.23,7.01-9.38,20.67l3.28,22.5-.3,17.13-.23,3.06,2.53,2.51.52,1.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m257.22,341.71h-.19l-.04.95h-4.55l.12-1.26h.15s0-.02,0-.02l1.04-4.63h4.72l.1.61,1.15,1.6,6.9,1.97s.54.24.53.54l-.02.55v.33s-.1.15-.66.31h-7.91l-.48-.64-.47-.29-.4-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m219.74,341.71h-.19l-.04.95h-4.55l.12-1.26h.15s0-.02,0-.02l1.04-4.63h4.72l.1.61,1.15,1.6,6.9,1.97s.54.24.53.54l-.02.55v.33s-.1.15-.66.31h-7.91l-.48-.64-.47-.29-.4-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "255.71 344.77 255.94 344.78 255.94 344.77 255.71 344.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "221.61 337.31 214.59 336.76 218.27 282.64 220.91 247.01 220.64 241.59 222.49 236.89 222.42 234.29 239.79 234.29 239.34 239.16 229.58 284.73 221.61 337.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "259.06 337.33 251.92 337.7 244.27 284.49 235.82 237.79 235.82 234.29 252.77 234.29 253.5 240.06 255.71 283.28 259.06 337.33"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "283.79 146.73 282.35 147.03 281.69 148.29 280.99 150.41 283.22 147.99 283.29 147.68 283.83 147.4 284.33 146.91 283.79 146.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m287.88,149.42l-.77-.91,1-1.39c.19-.2.51-.21.71-.02.2.19.21.51.02.71l-.95,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m289.25,148.12c.4.3.18.77.11.94-.24.62-.52,1.37-.52,1.37l-.18.23-.61-1.21s.36-.8.67-1.14c.11-.12.27-.39.53-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m287.09,148.3l-.93-.88,1.32-1.28c.18-.21.5-.22.71-.04.21.18.22.5.04.71l-1.13,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m286.03,147.32l3.12-4.08c.18-.21.16-.53-.05-.71-.21-.18-.53-.16-.71.05l-3.53,3.83,1.17.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m284.95,146.32l-1.25,1.21-.5.42-1.9,1.59-.67,1.99-4.89,7.55,4.11,2.31,4.59-6.34,2.68-2.3,1.72-2.29c-.28-1.56-1.84-3.02-1.84-3.02-1.13-1.08-1.91-1.12-2.03-1.12Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "283.03 148.13 283.21 147.64 284.13 147.12 283.03 148.13"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m283.58,157.89l-5.52-3.63-11.76,15.09-21.55-2.53c-1.7.49-2.5,1.71-3.3,2.77h0c-1.01,1.33-1.34,3.06-.88,4.67l.13.46c.38,1.35,1.3,2.49,2.53,3.14h0c1.11.59,2.36.45,3.61.48,9.67.22,21.78-.71,21.78-.71l2.02-1.29,12.95-18.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m211.65,234.69l1.16,3.3.34,2.01s0,0,0,0c0,0,0,0,0,0,0,0-.01.91-.05,1.21-.01.11-.06.23-.14.31,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.08.07-.19.11-.33.08-.3-.06-.46-.47-.51-1.26l-.08-.38-.02-.09h0s-.3-.67-.3-.67h0s-.2-.3-.2-.3l-.16,1.73c-.09.07-.68.49-2.14.35,0,0-1.99-.18-3.1-1.17l.26-4.11.67-1.99.86-8.51,4.75.61-.98,8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m207.83,245.04l-.02.13c-.04.26-.28.43-.53.4-.26-.04-.43-.28-.4-.53l.02-.17.51-4.7,1.08.28-.67,4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m206.55,243.61c-.04.26-.28.43-.54.39-.26-.04-.43-.28-.39-.54l.04-.29.44-3.57,1.12.51-.64,3.28-.03.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m209.29,245.99c-.03.26-.26.44-.51.42-.26-.03-.44-.26-.42-.51v-.04s.38-5.39.38-5.39l1.19.15-.63,5.32v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m211.02,245.27l-.02.32c-.01.26-.24.46-.5.44-.26-.01-.46-.24-.44-.5v-.16s.11-4.79.11-4.79l1.17-.1-.32,4.77h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "211.49 238.93 210.28 237.95 209.75 236.14 210.19 238.12 211.49 239.2 211.49 238.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m226.78,176.48c-.25,1.97-1.12,4.65-1.12,4.65l-9.44,27.57-3.4,23.73-6.69-.57,1.55-24.03.36-2.31s6.49-27.09,10.22-32.75c.69-1.05,2.76-2.32,4.43-1.78,2.15.69,4.54,1.92,4.09,5.5Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "229.88 166.32 237.78 165.91 238.35 167.2 229.46 167.68 229.88 166.32"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m516.89,223.75l-.66,3.15c-1.29.67-3.23.36-3.23.36-1.42-.22-1.88-.76-1.95-.85l.27-1.68-.26.24h0s-.44.55-.44.55h0s-.04.08-.04.08l-.17.34c-.23.74-.49,1.09-.79,1.07-.14,0-.23-.07-.29-.16,0,0-.01,0-.02-.02,0,0,0,0,0,0,0,0,0,0,0,0-.06-.1-.08-.21-.06-.33.04-.29.25-1.16.25-1.16,0,0,0,0,0,0,0,0,0,0,0,0l.8-1.83,1.89-2.86-.84-8.13,4.57-.26.53,6.74.45,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m513.32,231.41v.12c-.04.25.14.48.4.5.25.03.48-.16.5-.41l.02-.17.65-4.59h-1.1s-.47,4.53-.47,4.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m514.88,230.36c-.02.25.16.48.42.5.25.02.48-.16.5-.42l.03-.28.44-3.5-1.18.22-.18,3.27-.02.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m511.71,231.96c-.04.25.14.48.39.52.25.04.48-.14.52-.39v-.04s.95-5.21.95-5.21l-1.17-.15-.68,5.2v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m510.24,230.86l-.06.31c-.05.25.11.49.36.54.25.05.49-.11.54-.36l.03-.15,1.06-4.56-1.09-.38-.84,4.61h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "511.31 224.74 512.7 224.1 513.63 222.51 512.74 224.28 511.25 224.99 511.31 224.74"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "511.55 217.65 516.55 216.89 516.72 218.81 511.77 219.43 511.55 217.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m493.04,171.3c.42,1.9,1.53,4.42,1.53,4.42l13.2,19.83,3.51,23.27,5.61-.85-.87-22.99-.91-2.91s-9.95-20.04-14.12-25.2c-.77-.95-2.91-2-4.48-1.32-2.03.88-4.24,2.3-3.47,5.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m502.89,179.98l-1,6.73.52.78s.56-5.65.48-7.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m521.1,240.13l-112.75-43.74,5.1-13.19,112.75,43.74c.22.09.33.33.24.55l-4.79,12.39c-.09.22-.33.33-.55.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m516.61,241.72l-82.85-32.18c-2.08-.81-3.12-3.15-2.32-5.23l4.41-11.42c.81-2.08,3.15-3.12,5.23-2.32l82.85,32.18c2.08.81,3.12,3.15,2.32,5.23l-4.41,11.42c-.81,2.08-3.15,3.12-5.23,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m523.75,228.24c.77-1.98-.22-4.22-2.2-4.98l-79.64-30.92c-1.98-.77-4.22.22-4.98,2.2l-.39,1,86.83,33.71.39-1.01Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m348.68,124.59c-1.27.44-2.53.94-3.78,1.49-24.81,10.98-36.07,40.1-25.09,64.92,10.98,24.82,40.11,36.06,64.92,25.09,24.81-10.98,36.07-40.1,25.09-64.92-10.43-23.57-37.22-34.9-61.14-26.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m345.09,114.23c-1.55.54-3.09,1.15-4.62,1.82-30.35,13.43-44.11,49.04-30.68,79.38,13.43,30.35,49.05,44.09,79.39,30.68,30.34-13.43,44.11-49.04,30.68-79.38-12.75-28.82-45.51-42.68-74.76-32.5Zm39.65,101.86c-24.8,10.97-53.94-.27-64.92-25.09-10.98-24.81.28-53.94,25.09-64.92,1.25-.55,2.51-1.05,3.78-1.49,23.92-8.32,50.71,3.01,61.14,26.58,10.98,24.81-.27,53.93-25.09,64.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m348.68,124.59c-1.27.44-2.53.94-3.78,1.49-24.81,10.98-36.07,40.1-25.09,64.92,10.98,24.82,40.11,36.06,64.92,25.09,24.81-10.98,36.07-40.1,25.09-64.92-10.43-23.57-37.22-34.9-61.14-26.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m347.64,121.7c-27.27,9.49-41.69,39.29-32.2,66.57,9.49,27.28,39.29,41.69,66.57,32.2,27.27-9.49,41.69-39.29,32.2-66.57-9.49-27.27-39.29-41.69-66.57-32.2Zm37.1,94.39c-24.8,10.97-53.94-.27-64.92-25.09-10.98-24.81.28-53.93,25.09-64.92,1.25-.55,2.51-1.05,3.78-1.49,23.92-8.32,50.71,3.01,61.14,26.58,10.98,24.81-.27,53.93-25.09,64.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m347.64,121.7c-27.27,9.49-41.69,39.29-32.2,66.57,9.49,27.28,39.29,41.69,66.57,32.2,27.27-9.49,41.69-39.29,32.2-66.57-9.49-27.27-39.29-41.69-66.57-32.2Zm37.1,94.39c-24.8,10.97-53.94-.27-64.92-25.09-10.98-24.81.28-53.93,25.09-64.92,1.25-.55,2.51-1.05,3.78-1.49,23.92-8.32,50.71,3.01,61.14,26.58,10.98,24.81-.27,53.93-25.09,64.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m411.18,154.95c8.91,25.6-4.63,53.58-30.23,62.49-25.6,8.91-53.58-4.63-62.49-30.23-8.91-25.6,4.63-53.58,30.23-62.49,25.6-8.91,53.58,4.63,62.49,30.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m406.25,156.67c7.96,22.88-4.14,47.88-27.02,55.84-22.88,7.96-47.88-4.14-55.84-27.02-7.96-22.88,4.14-47.88,27.02-55.84,22.88-7.96,47.88,4.14,55.84,27.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m366.47,148.8c15.71-1.17,30.13,2.32,40.27,8.78-.1-.32-.2-.65-.31-.98-8-22.98-33.11-35.13-56.09-27.14-18.37,6.39-29.8,23.71-29.58,42.14,7.67-12.06,24.99-21.27,45.71-22.81Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 480.76,
    y: 157.62,
    width: 11.38,
    height: 7.11,
    transform: "translate(289.5 634.27) rotate(-85.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m479.49,149.23c-.97,4.25-.2,7.71,5.4,8.41,3.69.46,6.75-1.17,7.72-5.41.14-.6,2.23-8.26,2.25-8.84l-2.27-2.92-5.06-2.7-4.6.25c-.07.15-1.95,1.23-2.47,3.94-.48,2.52-.86,6.85-.96,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m483.77,151.07l.61-2.91.23-1.7-.74-.36-1.41,1.41-.75-.46c.17-.55-.05-1.81.26-2.99.05-.19-.41-.58-.36-.77.26-1,.56-2,.76-2.65-.66-.34-1.2-.87-1.66-2.13-.92-2.53.1-3.99,1.02-4.56.46-.29,1.9-.71,4.96.7,3.05,1.41,3.25-.17,5.08.86,2.9,1.62,5.2,6.03,4.73,9.39-.36,2.54-1.39,5.15-2.23,6.4l-1.68,3.01-1.44,1.18-5.31-.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m510.68,332.52h.19l.04.93h4.44l-.12-1.23h-.14s0-.01,0-.01l-1.61-4.3h-4.61l-.1.59-2.13,1.56-5.13,1.71s-.53.23-.52.52l.02.53v.32s.09.14.64.3h7.72l.47-.62.45-.29.39-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m464.01,333.27h.19l.04.93h4.44l-.12-1.23h-.15s0-.01,0-.01l-1.01-4.51h-4.61l-.1.59-1.13,1.56-6.73,1.93s-.53.23-.52.52l.02.53v.32s.09.14.64.3h7.72l.47-.62.45-.29.39-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "464.97 336.27 464.76 336.28 464.76 336.27 464.97 336.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "507.05 328.96 514.37 327.81 501.63 275.45 499.04 236.43 499.31 231.12 497.5 226.53 497.56 223.98 480.56 223.98 481 228.75 490.55 277.49 507.05 328.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "461.22 328.99 468.69 329.35 476.17 277.26 484.45 227.41 484.45 223.98 467.85 223.98 467.14 229.63 464.97 276.07 461.22 328.99"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m464.17,228.25s5.12-20.99,5.23-27.85c.08-4.85-.65-9.38-.66-15.73-.03-9.86,1.65-14.41,3.17-19.74.95-3.35,4.28-2.92,5.89-2.87,1.29.04,4,.32,4,.32l11.52.62c9.08,1.46,10.99,6.87,9.19,20.24l-3.21,17.89,1.44,27.67s-3.85,2.78-18.29,1.27c-5.04-.53-18.28-1.81-18.28-1.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "490.26 161.58 482.53 161.17 481.97 162.44 490.67 162.91 490.26 161.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m438.9,208.02l2.75.21,4.14-3.86,3.65,3.14-6.56,5.17-2.67.72-3.98-.47c-1.53-.86-3.32-3.02-3.32-3.02v-.81s2.62,1.15,2.62,1.15l3.22-.25.41-.34-1.27-.66-1.22-.05-.41-.58.12-.26,2.53-.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "443.63 205.86 442.13 207.16 446.34 211.22 447.94 209.76 443.63 205.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m471.85,164.26c-1.18,1.54-2.41,4.01-2.41,4.01l-14.71,25.82-12.18,12.29,5.06,4.2,12.68-9.85,1.1-1.07s17.67-25.64,18.94-32.15c.24-1.2-.34-3.52-1.87-4.28-1.97-.99-4.49-1.77-6.63,1.03Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m474.13,179.98l-5.3,8.49.1,1.83s4.84-9.01,5.2-10.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.14a180779d0fdcca72b9d13e67970bfb.svg";
export { ForwardRef as ReactComponent };